import { render } from "./TopHeader.vue?vue&type=template&id=e67f9354"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/innovation/Documents/project/for small pos/BioLab/clientnew/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__